<template>
  <!-- 编辑修改乘机人 修改出行人-->
  <div>
    <van-popup
      v-model="isShow"
      lock-scroll
      lazy-render
      position="right"
      class="full-height full-width"
      :close-on-popstate="true"
      :close-on-click-overlay="false"
      :get-container="getContainer"
    >
      <div class="full-height">
        <ld-header @click-left="toggle">
          {{ $t('C184', '修改出行人') }}
        </ld-header>

        <van-cell-group>
          <van-field
            :label="$t('C114','乘客类型')"
            v-model="psgTypeName"
            input-align="left"
            disabled
          />

          <van-field
            :label="$t('D007','姓名')"
            :placeholder="$t('D007','姓名')"
            v-model="name"
            input-align="left"
            :disabled="canedit(psgInfo)"
          />

          <van-field
            :label="$t('D003','证件类型')"
            v-model="psgInfo.cardName"
            is-link
            @click="showCardType = !showCardType"
            input-align="left"
            readonly
          />
          <van-action-sheet
            v-model="showCardType"
            :actions="CARD_TYPE"
            @select="cardTypeSelect"
          />

          <van-field
            :label="$t('D008','证件号码')"
            v-model="psgInfo.cardNo"
            @input="cardNumberInput"
            :placeholder="$t('D008','证件号码')"
            clearable
            @blur="changeInfoVerificate()"
            :disabled="canedit(psgInfo)"
          />

          <van-field
            v-if="expiryDateShow"
            :label="$t('Q214','有效期')"
            v-model="psgInfo.expiryDate"
            is-link
            @click="showExpiryDate = !showExpiryDate"
            input-align="left"
            readonly
          />
          <van-popup
            lock-scroll
            v-model="showExpiryDate"
            position="bottom"
          >
            <van-datetime-picker
              v-model="expiryDate"
              type="date"
              :min-date="EXPIRY_MIN"
              :max-date="EXPIRY_MAX"
              @cancel="showExpiryDate != false"
              @confirm="expiryDateSelect"
            />
          </van-popup>

          <van-field
            v-if="issueDateShow"
            :label="$t('Q511','签发日期')"
            v-model="psgInfo.dateOfIssue"
            is-link
            @click="showIssueDate = !showIssueDate"
            input-align="left"
            readonly
          />
          <van-popup
            lock-scroll
            v-model="showIssueDate"
            position="bottom"
          >
            <van-datetime-picker
              v-model="dateOfIssue"
              type="date"
              :min-date="ISSUE_MIN"
              :max-date="ISSUE_MAX"
              @cancel="showIssueDate != false"
              @confirm="issueDateSelect"
            />
          </van-popup>

          <van-field
            v-if="bornShow"
            :label="$t('D013','出生日期')"
            v-model="psgInfo.born"
            is-link
            @click="showDate = !showDate"
            input-align="left"
            readonly
          />
          <van-popup
            lock-scroll
            v-model="showDate"
            position="bottom"
          >
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              :min-date="BORN_MIN"
              :max-date="BORN_MAX"
              @cancel="showDate = false"
              @confirm="bornSelect"
            />
          </van-popup>

          <!-- 国籍 -->
          <van-field
            v-if="nationShow"
            :label="$t('D017','国籍')"
            v-model="psgInfo.nationName"
            is-link
            @click="$refs['nation'].toggle()"
            input-align="left"
            readonly
          />
          <ld-nation
            ref="nation"
            @selected="nationSelect"
          />

          <van-field
            type="number"
            max="13"
            clearable
            v-model="psgInfo.phoneNumber"
            :error-message="phoneErrMsg"
            placeholder="手机号码"
            @blur="changeInfoVerificate('phoneNumber', '手机号码')"
            :disabled="canedit(psgInfo)"
          >
            <span slot="label">
              手机号码
            </span>
          </van-field>

          <verificate
            ref="verificate"
            :psg-info="psgInfo"
          />

          <van-field
            v-if="emailShow"
            clearable
            label="联系邮箱"
            placeholder="联系邮箱"
            :error-message="emailErrMsg"
            v-model="psgInfo.email"
            @blur="changeInfoVerificate('email', '联系邮箱')"
          />
        </van-cell-group>

        <van-row class="round-sm mt5 pad8 orange bg-lightYellow">
          温馨提示：<br>
          1、根据铁路局防疫规定，铁路乘客需填写手机号以便需要时随时联系。<br>
          2、互联网售票实行实名制，请准确填写乘车人基本信息。
        </van-row>

        <div class="pad">
          <ld-button
            main
            size="lg"
            @click.native="comple(true)"
          >
            {{ $t('B006', '确定') }}
          </ld-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {ActionSheet, Cell, CellGroup, DatetimePicker, Field, Popup} from 'vant'
import {mapGetters} from 'vuex'
import {validators} from 'Utils/valid'
import {formatDate} from 'Utils/dateUtil'
import {arrToMap} from 'Utils/tools'
import verificate from './verificate'
import ldNation from 'Components/ldNation'
import ldButton from 'Common/ldButton'
import {excludeSpecial} from 'Utils/string'

/**
 * 乘机人类型
 * @desc 火车票专用
 */
const PSG_TYPE = [
  {key: '1', name: '成人'},
  {key: '2', name: '儿童'}
]

/**
 * 身份证类型
 * @desc 火车票专用
 */
const CARD_TYPE = [
  {key: '1', name: '身份证', row: 'idNumber'},
  {key: 'B', name: '护照', row: 'passport', periodRow: 'passportPeriod', issueRow: 'passportDateOfIssue'},
  {key: 'C', name: '港澳居民来往内地通行证', row: 'otherNumber', periodRow: 'otherPeriod', issueRow: 'otherDateOfIssue'},
  {key: 'G', name: '台湾居民来往大陆通行证', row: 'otherNumber', periodRow: 'otherPeriod', issueRow: 'otherDateOfIssue'},
  {key: 'H', name: '外国人永久居留身份证', row: 'otherNumber', periodRow: 'otherPeriod', issueRow: 'otherDateOfIssue'},
  {key: '2', name: '港澳台居民居住证', row: 'otherNumber', periodRow: 'otherPeriod', issueRow: 'otherDateOfIssue'}
]

export default {
  name: 'LdEditPsg',
  components: {
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    ldButton,
    ldNation,
    verificate
  },
  props: {
    psgInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    element: {
      type: String,
      default: ''
    }
  },
  updated() {
    this.getNationList()
    console.log('this this.psgInfo', this.psgInfo)
    this.psgTypeName = this.psgInfo.psgType == 2?"儿童":"成人";
  },
  data() {
    return {
      name: '',
      isShow: false,
      showPsgType: false,
      showCardType: false,
      showDate: false,
      showExpiryDate: false,
      showIssueDate: false,
      psgTypeName: PSG_TYPE[0].name,
      expiryDate: new Date(),
      dateOfIssue: new Date(),
      currentDate: new Date(),
      BORN_MIN: new Date('1940-01-01'),
      BORN_MAX: new Date(),
      EXPIRY_MIN: new Date(),
      EXPIRY_MAX: new Date('2099-12-30'),
      ISSUE_MIN: new Date('1940-01-01'),
      ISSUE_MAX: new Date(),
      PSG_TYPE, CARD_TYPE,
      phoneErrMsg: '',
      emailErrMsg: '',
      nationList: [],
      zjh: '',
      zjhNotEdit: false
    }
  },
  computed: {
    ...mapGetters({
      trSearchInfo: 'tr/trSearchInfo',
      travelerList: 'tr/travelerList',
      userInfo: 'userInfo',
      pageCtrl: 'serviceCtrl', //页面控制信息
    }),
    /**
     * 火车票 护照(B)、港澳居民来往内地通行证(C)、台湾居民来往大陆通行证(G)、外国人永久居留身份证(H) 要选
     */
    bornShow() {
      let valid = ['B', 'C', 'G', 'H']
      if (valid.indexOf(this.psgInfo.cardType) > -1) {
        return true
      } else {
        return false
      }
    },
    /**
     * 火车票 护照(B)、港澳居民来往内地通行证(C)、台湾居民来往大陆通行证(G)、外国人永久居留身份证(H) 要选
     */
    expiryDateShow() {
      let valid = ['B', 'C', 'G', 'H']
      if (valid.indexOf(this.psgInfo.cardType) > -1) {
        return true
      } else {
        return false
      }
    },
    /**
     * 火车票 护照(B)、港澳居民来往内地通行证(C)、台湾居民来往大陆通行证(G)、外国人永久居留身份证(H) 要选
     */
    issueDateShow() {
      let valid = ['B', 'C', 'G', 'H']
      if (valid.indexOf(this.psgInfo.cardType) > -1) {
        return true
      } else {
        return false
      }
    },
    /**
     * 火车票 护照(B)、外国人永久居留身份证(H) 要选
     */
    nationShow() {
      let valid = ['B', 'H']
      if (valid.indexOf(this.psgInfo.cardType) > -1) {
        return true
      } else {
        return false
      }
    },
    /**
     * 火车票 除身份证外 要填
     */
    emailShow() {
      let valid = ['1']
      if (valid.indexOf(this.psgInfo.cardType) === -1) {
        return true
      } else {
        return false
      }
    },
  },
  created() {
  },
  methods: {
    async getNationList() {
      await this.$api['common/getFindNationList']().then(res => {
        let cache = res.data || {}
        let list = cache.nations || []
        if (list.length > 0) {
          this.nationList = list
        }
      })
      const mapNationsId = arrToMap(this.nationList, 'id')
      const mapNationsBy3 = arrToMap(this.nationList, 'by3')
      let nationName = mapNationsId[this.psgInfo.nation]
      if (nationName === undefined) {
        nationName = mapNationsBy3[this.psgInfo.nation]
      }
      this.psgInfo.nationName = nationName.cName
    },
    canedit(psg) {
      // if (this.pageCtrl.isShowCcsqd){ //lxy:出差申请模式不允许修改出行人姓名
      //   return true
      // }
      // return !((this.userInfo.vipCorp.tripType == 1 && this.userInfo.vipCorp.bookStyle == 2) || psg.empId || psg.conempId)
      // if (this.userInfo && this.userInfo.vipCorp && this.userInfo.vipCorp.bookStyle && this.userInfo.empInfo) {
      if (this.userInfo && this.userInfo.vipCorp && this.userInfo.empInfo) {
        const reg = /^(?:\d+)(.{4})$/
        // 申请单模式用户端统一不能修改人员信息
        // if (this.userInfo.vipCorp.bookStyle === 2) {
        //   this.zjh = psg.cardNumber.replace(reg, '****\$1');
        //   this.zjhNotEdit = true;
        //   return true;
        // }
        // if (this.userInfo.vipCorp.bookStyle === 1 && this.userInfo.empInfo.xgygxx === 0) {
        if (this.userInfo.empInfo.xgygxx === 0) {
          this.zjh = psg.cardNo.replace(reg, '****\$1')
          this.zjhNotEdit = true
          return true
        }
      }
      this.zjh = psg.cardNo
      return false
    },
    cardNumberInput(val) {
      val = excludeSpecial(val)
      this.$set(this.psgInfo, 'cardNumber', val)
      this.$forceUpdate()
    },
    /**
     * 证件类型选择回调
     */
    cardTypeSelect(item) {
      if (this.psgInfo.cardType != item.key) this.changeInfoVerificate()
      this.showCardType = false
      this.psgInfo.cardNumber = ''
      this.psgInfo.cardName = item.name
      this.psgInfo.cardType = item.key
      this.echoCardType()
    },
    /**
     * 出生日期选择回调
     */
    bornSelect(item) {
      this.showDate = false
      this.psgInfo.born = formatDate(item).date
    },
    /**
     * 有效期选择回调
     */
    expiryDateSelect(item) {
      this.showExpiryDate = false
      this.psgInfo.expiryDate = formatDate(item).date
    },
    /**
     * 证件签发日期选择回调
     */
    issueDateSelect(item) {
      this.showIssueDate = false
      this.psgInfo.dateOfIssue = formatDate(item).date
    },
    /**
     * 国籍选择回调
     */
    nationSelect(city) {
      this.psgInfo.nationName = city.cName
      this.psgInfo.nation = city.by3
      this.$forceUpdate()
    },
    /**
     * 新增的出行人
     * 回显证件类型，证件号码和证件有效期
     */
    echoCardType() {
      CARD_TYPE.forEach(type => {
        if (type.key == this.psgInfo.cardType) {
          this.psgInfo.cardNumber = this.psgInfo[type.row]
          if (type.periodRow) {
            this.psgInfo.expiryDate = this.psgInfo[type.periodRow]
            this.expiryDate = new Date(this.psgInfo[type.periodRow])

            this.psgInfo.dateOfIssue = this.psgInfo[type.issueRow]
            this.dateOfIssue = new Date(this.psgInfo[type.issueRow])
          }
        }
      })
    },
    /**
     * 确定按钮
     * 回填乘车人信息
     */
    comple(show = false) {

      if (this.phoneErrMsg !== '') return
      if (this.emailErrMsg !== '') return
      if (this.bornShow && !this.psgInfo.born) {
        this.$validErrorTips('出生日期不能为空')
        return
      }

      if (this.expiryDateShow && !this.psgInfo.expiryDate) {
        this.$validErrorTips('证件有效期不能为空')
        return
      }

      if (this.nationShow && !this.psgInfo.nationName) {
        this.$validErrorTips('国籍不能为空')
        return
      }

      if (this.emailShow && (!this.psgInfo.phoneNumber && !this.psgInfo.email)) {
        this.$validErrorTips('请填写联系手机/联系邮箱')
        return
      }

      /**
       * 证件号码填到对应字段
       */
      let type = CARD_TYPE.find(type => type.key == this.psgInfo.cardType)
      // this.psgInfo[type.row] = this.psgInfo.cardNumber
      this.psgInfo[type.row] = this.zjhNotEdit ? this.psgInfo.cardNumber : this.zjh

      this.$emit('selected', this.psgInfo)

      if (show) this.toggle()
      this.isShow = false

    },
    changeInfoVerificate(attr, desc) {
      if (this.psgInfo.psgType == '2') return false

      if (attr) {
        for (var i = 0; i < this.travelerList.length; i++) {
          var $psg = this.travelerList[i]
          if ($psg != this.psgInfo && $psg[attr] === this.psgInfo[attr]) {
            this.$dialog({message: '您输入的' + desc + '已被乘客' + this.$options.filters.getName($psg) + '使用，请确认乘车人联系方式的唯一性'})
            return false
          }
        }
      }
      this.psgInfo.yzm = ''
      this.psgInfo.checkCode = '0'
      this.$forceUpdate()
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if (this.element) {
        return document.querySelector(this.element)
      }
      return ''
    },
    toggle() {
      this.isShow = !this.isShow
    }
  },
  watch: {
    psgInfo(val) {
      if (val) {
        if (!val.psgType) this.$set(val, 'psgType', PSG_TYPE[0].key)
        if (!val.cardType) this.$set(val, 'cardType', CARD_TYPE[0].key)

        this.cardTypeSelect(CARD_TYPE.find(type => type.key == val.cardType))

        this.currentDate = val.born ? new Date(val.born) : new Date('1980-01-01')
        this.psgInfo = val
        this.name = this.$options.filters.getName(this.psgInfo)
        this.$forceUpdate()
      }
    },
    'psgInfo.phoneNumber': function (val) {
      this.psgInfo.phoneNumber = excludeSpecial(val)
      if (val && !validators.mobile(val).valid) {
        this.phoneErrMsg = validators.mobile(val).msg
      } else {
        this.phoneErrMsg = ''
      }
    },
    'psgInfo.email': function (val) {
      if (val && !validators.email(val).valid) {
        this.emailErrMsg = validators.email(val).msg
      } else {
        this.emailErrMsg = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pad {
  padding: 20px;
}
</style>
